import React from 'react';

import { Button, ExpansionPanel, Icon } from '@cision/rover-ui';
import { CollapseProps } from '@cision/rover-ui/dist/components/Collapse/Collapse';

import { Subhead } from '@trendkite/ui';
import globalMessages from 'i18n/Global.messages';
import TranslatedMessage from 'i18n/TranslatedMessage';

import style from './FilterPanel.module.css';

/**
 * As we're not exporting the interfaces of the components in Rover-UI
 * and using `typeof ExpansionPanel` would bring things like ExpansionPanel.Header
 * and ExpansionPanel.Body, we're re-defining the props for the component here,
 * so that we can extend them properly.
 */
interface ExpansionPanelProps {
  className?: string;
  id?: string;
  collapseProps?: CollapseProps;
  defaultExpanded?: boolean;
  expanded?: boolean;
  onToggle?: (event: React.SyntheticEvent, expanded: boolean) => void;
  onClick?: (...args: any) => void;
}

interface FilterPanelProps extends ExpansionPanelProps {
  title: string;
  clearButtonText?: string;
  bodyClassName?: string;
  onClear?: (...args: any) => void;
  showClearButton: boolean;
  showBody?: boolean;
  defaultExpanded?: boolean;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  title,
  bodyClassName = '',
  clearButtonText = '',
  children = null,
  onClear = () => {},
  showBody = false,
  showClearButton = false,
  ...otherProps
}) => (
  <ExpansionPanel {...otherProps}>
    <ExpansionPanel.Header
      expandIcon={<Icon name="chevron-down" />}
      className={style.header}
    >
      <div className={style.headerContent}>
        <Subhead color="dark">{title}</Subhead>
        {showClearButton && (
          <Button
            data-qa="EyL3fmERwbVLhgojFmPtL"
            className={style.clearButton}
            level="text"
            size="sm"
            onClick={onClear}
          >
            {clearButtonText || <TranslatedMessage {...globalMessages.clear} />}
          </Button>
        )}
      </div>
    </ExpansionPanel.Header>
    <ExpansionPanel.Body>{children}</ExpansionPanel.Body>
  </ExpansionPanel>
);

export default FilterPanel;
